// WARNING Mirrored in FE/BE - keep in sync. Counterpart: backend/src/documents/src/importDocx/postprocess/puppeteer/materializeTabWidths.ts

export const TAB_NODE_NAME = 'docx-tab-node';

export const DEFAULT_TAB_WIDTH = 48; // 0.5"
export const EPS = 0.5; // fixed CSS-px tolerance (independent of DPR)

// Quantization grid - absorb cross-platform font rendering variance
export const QUANTUM = 0.5;

export const DOCX_TAB_PERSIST = 'docxTabPersist';
// Editor-only signal: finish queued layout before the save owner captures HTML.
export const DOCX_TAB_FLUSH = 'docxTabFlush';
